import { Box } from "@mui/material";
import { getMonthName } from "utils/date";

const SalesHistory = ({ items }) => {
  return (
    <Box
      sx={{
        p: 4,
        color: "#fff",
      }}
    >
      Ventas mensuales
      {items.map((item) => (
        <li key={item.month}>
          {getMonthName(item.month.split("-")[1])} -
          {item.totalOrderPrice.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </li>
      ))}
    </Box>
  );
};
export default SalesHistory;
